/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CommitLineupLockChangesInput = {|
  lineupLockChanges?: ?$ReadOnlyArray<?LineupLockInput>,
  clientMutationId?: ?string,
|};
export type LineupLockInput = {|
  gmLineupId: string,
  locked: boolean,
|};
export type CommitLineupLockChangesMutationVariables = {|
  input: CommitLineupLockChangesInput
|};
export type CommitLineupLockChangesMutationResponse = {|
  +commitLineupLockChanges: ?{|
    +success: ?boolean
  |}
|};
export type CommitLineupLockChangesMutation = {|
  variables: CommitLineupLockChangesMutationVariables,
  response: CommitLineupLockChangesMutationResponse,
|};
*/


/*
mutation CommitLineupLockChangesMutation(
  $input: CommitLineupLockChangesInput!
) {
  commitLineupLockChanges(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CommitLineupLockChangesPayload",
    "kind": "LinkedField",
    "name": "commitLineupLockChanges",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommitLineupLockChangesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommitLineupLockChangesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3687c631aca777c2063704b73789d688",
    "id": null,
    "metadata": {},
    "name": "CommitLineupLockChangesMutation",
    "operationKind": "mutation",
    "text": "mutation CommitLineupLockChangesMutation(\n  $input: CommitLineupLockChangesInput!\n) {\n  commitLineupLockChanges(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3ca97aea50e938905f6935815464c1c6';

module.exports = node;
